/* Size picker on product cards outside the product page — chips in the cart
   drawer, a <select> in the product-page upsell carousel. Delegated from the
   document so cards rendered after load are covered too. */
(function () {
  function formFor(picker) {
    var wrap = picker.closest('product-form') || picker.closest('form')?.parentElement;
    return (wrap && wrap.querySelector('form')) || picker.closest('form');
  }

  /* Whichever control this card uses, the answer is a variant id or null. */
  function chosenVariant(picker) {
    var sel = picker.querySelector('[data-amb-cardsize-select]');
    if (sel) return sel.value || null;
    var chip = picker.querySelector('.amb-cardsize__chip.is-selected');
    return chip ? chip.dataset.variant : null;
  }

  function sync(picker) {
    var form = formFor(picker);
    if (!form) return;
    var hidden = form.querySelector('input[name="id"]');
    var btn = form.querySelector('button[name="add"]');
    var chosen = chosenVariant(picker);
    if (hidden) {
      if (chosen) { hidden.value = chosen; hidden.disabled = false; }
      else { hidden.disabled = true; }
    }
    if (btn) {
      var label = btn.querySelector('.btn-action');
      if (!chosen) {
        btn.setAttribute('disabled', 'disabled');
        if (label && !btn.dataset.ambLabel) btn.dataset.ambLabel = label.textContent.trim();
        // Liquid hands us the translated string; JS has no `t` filter.
        if (label) label.textContent = picker.dataset.labelSelect || 'Select a size';
      } else {
        btn.removeAttribute('disabled');
        if (label && btn.dataset.ambLabel) label.textContent = btn.dataset.ambLabel;
      }
    }
  }

  function init(picker) {
    if (picker.dataset.ambReady) return;
    picker.dataset.ambReady = '1';
    sync(picker);
  }

  document.addEventListener('click', function (e) {
    var chip = e.target.closest('.amb-cardsize__chip');
    if (!chip || chip.disabled) return;
    e.preventDefault();
    var picker = chip.closest('[data-amb-cardsize]');
    picker.querySelectorAll('.amb-cardsize__chip')
          .forEach(function (c) { c.classList.toggle('is-selected', c === chip); });
    sync(picker);
  });

  document.addEventListener('change', function (e) {
    var sel = e.target.closest('[data-amb-cardsize-select]');
    if (!sel) return;
    sync(sel.closest('[data-amb-cardsize]'));
  });

  function scan() { document.querySelectorAll('[data-amb-cardsize]').forEach(init); }
  document.addEventListener('DOMContentLoaded', scan);
  new MutationObserver(scan).observe(document.documentElement, { childList: true, subtree: true });
  scan();
})();
